// Az üzenet-tartalom KÖZÖS 5 mezője (tárgy + törzs + 3 link) — a compose- ÉS az edit-sheet is ezt rendereli
// (a mező-nevek 1:1 a MessageContentValues kulcsai; a compose-form értékei ennek szuperhalmaza, a FormField
// a FormProvider-kontextusból veszi a controlt).
//
// A TÖRZS RICH-TEXT (TipTap), mint a legacy WYSIWYG-je: a form-érték HTML, a tárolt HTML nyílik meg
// szerkesztésre. A KÉP-GOMB ITT IS MŰKÖDIK: egy „mindenkinek" szóló üzenetnek nincs cél-ügyfele,
// de a fájlnak nem is kell ügyfél-kontextus — a BFF a BELSŐ (MORGENS) ügyfél-rekordot adja gazdának, ugyanazt,
// ami az üzenet-mellékleteket is tartja (a körlevelet a cég írja, tehát a kép is a cégé). Korábban a gomb meg
// sem jelent, mert az `imageAccountId` propot el sem adtuk — a user ezt „nem működik"-ként jelentette.
import { useTranslation } from 'react-i18next';

import { GoogleDriveMark, GoogleMeetMark, ZoomMark } from '@/components/brand/service-marks';
import { RichTextField, TextField } from '@/components/shared/form-fields';
import { Label } from '@/components/ui/label';
import { BODY_MIN_PLAIN, type MessageContentValues } from '@/features/messages/form';

export function MessageContentFields(): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <TextField<MessageContentValues>
        name="subject"
        label={t('messages.fields.subject')}
        required
        placeholder={t('messages.fields.subjectPlaceholder')}
      />
      <RichTextField<MessageContentValues>
        name="body"
        label={t('messages.fields.body')}
        required
        placeholder={t('messages.fields.bodyPlaceholder')}
        hint={t('messages.fields.bodyHint', { count: BODY_MIN_PLAIN })}
      />
      {/* LINKEK — EGY közös címke alatt a három mező (user-döntés): három egymás utáni, majdnem azonos címke
          („Google Drive link", „Google Meet link", „Zoom link") csak zaj volt. A mezőt a BELSŐ ikon azonosítja,
          a képernyőolvasónak pedig a `hideLabel` az `aria-label`-be teszi a nevet (nem hagyjuk el). A
          placeholderek maradnak — azok mutatják a várt URL-alakot. */}
      <div className="space-y-2">
        <Label className="block">{t('messages.fields.links')}</Label>
        <div className="space-y-2">
          <TextField<MessageContentValues>
            name="googleDriveLink"
            label={t('messages.fields.googleDriveLink')}
            hideLabel
            leadingIcon={<GoogleDriveMark className="size-4" />}
            placeholder="https://drive.google.com/…"
          />
          <TextField<MessageContentValues>
            name="googleMeetLink"
            label={t('messages.fields.googleMeetLink')}
            hideLabel
            leadingIcon={<GoogleMeetMark className="size-4" />}
            placeholder="https://meet.google.com/…"
          />
          <TextField<MessageContentValues>
            name="zoomLink"
            label={t('messages.fields.zoomLink')}
            hideLabel
            leadingIcon={<ZoomMark className="size-4" />}
            placeholder="https://zoom.us/j/…"
          />
        </div>
      </div>
    </>
  );
}
